import naja from "naja";

/**
 * Změní standardní vzhled paginace na jedno tlačítko s textem "Zobrazit další záznamy..."
 * Další stránka nepřepíše předchozí, ale přidá se na její konec.
 * Wrapper paginace vyžaduje data-naja-infinite-scroll, 
 * jehož hodnota odpovídá ID snippetu, kam se obsah přidává (v šabloně možno použít data-naja-infinite-scroll="{$control->getSnippetId('jméno-snippetu')}" )
 * Tlačítko odkazující na další stránku vyžaduje data-naja-next-page
 * Má-li wrapper paginace atribut data-naja-infinite-scroll-auto, bude se obsah načítat automaticky při doscrollování na konec stránky (v opačném případě jen po kliknutí na tlačítko)
 * Na straně serveru nutno nastavit odlišné chování při $this->getParameter('infiniteScroll', false) === true (překreslení pouze snippetu s položkami)
 */

export default class InfiniteScrollExtension {

    constructor() {
        this.loading = false; // využití při automatickém skrolování
        this.isAutoScroll;
        this.paginationWrapper;
        this.pagination;
        this.nextPageButton;
    }
    
    initialize(naja) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this.updatePagination();
                naja.addEventListener('complete', this.updatePagination.bind(this));
                window.addEventListener('scroll', this.scrollEvent.bind(this));
            });
        } else {
            this.updatePagination();
            naja.addEventListener('complete', this.updatePagination.bind(this));
            window.addEventListener('scroll', this.scrollEvent.bind(this));
        }
    }

    /**
     * Změní zobrazení tlačítek paginace. Ponechá pouze tlačítko na další stránku a změní jeho název.
     */
    updatePagination () {
        this.paginationWrapper = document.querySelector('[data-naja-infinite-scroll]');
        this.pagination = this.paginationWrapper?.querySelector('ul.pagination');
        if (this.pagination) {
            this.isAutoScroll = this.paginationWrapper.hasAttribute('data-naja-infinite-scroll-auto')
            this.nextPageButton = this.pagination.querySelector('a[data-naja-next-page]');
            if (this.nextPageButton) { // existuje ještě nějaká další stránka záznamů
                
                // do url odkazu přidá parametr infiniteScroll = true
                let url = new URL(this.nextPageButton.href)
                let searchParams = new URLSearchParams(url.search);
                searchParams.set('infiniteScroll', true);
                url.search = searchParams;
                this.nextPageButton.href = url.href;
    
                // načítání dalšího obsahu nevytváří další kroky v historii
                this.nextPageButton.dataset.najaHistory = 'replace';

                // přidá cílovému snippetu data-naja-snippet-append
                let targetSnippetId = this.paginationWrapper.dataset.najaInfiniteScroll;
                document.getElementById(targetSnippetId).dataset.najaSnippetAppend = '';

                if (!this.isAutoScroll) { // načtení dalšího obsahu až po kliknutí na tlačítko
                    // text tlačítka
                    this.nextPageButton.textContent = 'Zobrazit další záznamy...';
                    // vymaže ostatní tlačítka paginace
                    this.pagination.after(this.nextPageButton);
                    this.pagination.innerHTML = '';
                    this.pagination.append(this.nextPageButton);
                 } else { // načítání dalšího obsahu automaticky po scrollu
                    this.pagination.textContent = '';

                 }
                

            } else { // dosaženo poslední stránky záznamů
                this.pagination.textContent = 'Víc už tu není...';

            }
        }
    }


    scrollEvent() {
        if (!this.isAutoScroll) {
            return;
        }
        let windowRelativeBottom = document.documentElement.getBoundingClientRect().bottom;
        if ((windowRelativeBottom < (document.documentElement.clientHeight + 20)) && !this.loading && this.nextPageButton) {

            this.loading = true;
            naja.uiHandler.clickElement(this.nextPageButton)
            .then(()=>{
                this.loading = false;
            });
        }

    }


}